<template>
    <div class="CenteredContent">
        <h1 class="title">Emergency Contact</h1>
        <div class="inputContainer">
            <a-form :form="form" layout="horizontal">
                <a-row class="names" :gutter="{ xs: 16, sm: 36 }">
                    <a-col :xs="24" :sm="8">
                        <a-form-item label="First Name">
                            <a-input size="large" v-decorator="[
                                'Efirstname',
                                {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'First Name must exists',
                                        },
                                    ],
                                },
                            ]" />
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24" :sm="8">
                        <a-form-item label="Middle Name">
                            <a-input size="large" />
                        </a-form-item>
                    </a-col>

                    <a-col :xs="24" :sm="8">
                        <a-form-item label="Last Name">
                            <a-input size="large" v-decorator="[
                                'Elastname',
                                {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Last Name must exists',
                                        },
                                    ],
                                },
                            ]" />
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-form-item label="Contact telephone number">
                    <a-input size="large" placeholder="Area code not required,eg: 0000000000" v-decorator="[
                        'EphoneNumber',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Phone number is required',
                                },
                            ],
                        },
                    ]" />
                </a-form-item>
                <a-form-item label="Email address">
                    <a-input size="large" v-decorator="[
                        'Eemail',
                        {
                            rules: [
                                {
                                    required: true,
                                    message: 'Phone number should be provided',
                                },
                            ],
                        },
                    ]" />
                </a-form-item>
                <a-form-item>
                    <a-button size="large" type="primary" html-type="submit" @click="handleNext">Next Step</a-button>
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>
export default {
    props: ['handleCreate','defaultValue'],
    data() {
        return {
            form: this.$form.createForm(this, { name: "emergency", props: this.defaultValue })
        }
    },
    methods: {
        handleNext(e) {
            e.preventDefault()
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.handleCreate(values)
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.CenteredContent {
    padding: 6.25rem 5rem;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    .title {
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 40px;
        font-family: auto;
        text-align: center;
    }

    .inputContainer {
        width: 100%;
        max-width: 500px;
        padding: 2rem 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>